/**
 * Command palette explain drawer — ExplanatoryInline + assistive AI bridge.
 */

import React, { useEffect, useState } from 'react';
import { Drawer, Typography } from 'antd';
import { omitUndefined } from '@shared/utils/omitUndefined';
import { ExplanatoryInline } from '../workbench/ai';
import {
  WORKBENCH_PALETTE_EXPLAIN_REQUEST_EVENT,
  type WorkbenchPaletteExplainRequest,
} from '../../workbench/workbench-palette-explain-bridge';

const { Text } = Typography;

export function PaletteExplainDrawer(): React.ReactElement {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState<WorkbenchPaletteExplainRequest | null>(null);

  useEffect(() => {
    const onExplainRequest = (event: Event) => {
      const detail = (event as CustomEvent<WorkbenchPaletteExplainRequest>).detail;
      if (!detail?.tenantId || !detail.actionId) {
        return;
      }
      setRequest(detail);
      setOpen(true);
    };
    window.addEventListener(WORKBENCH_PALETTE_EXPLAIN_REQUEST_EVENT, onExplainRequest);
    return () => {
      window.removeEventListener(WORKBENCH_PALETTE_EXPLAIN_REQUEST_EVENT, onExplainRequest);
    };
  }, []);

  return (
    <Drawer
      title="작업 설명"
      open={open}
      onClose={() => {
        setOpen(false);
        setRequest(null);
      }}
      width={420}
      destroyOnHidden
      data-testid="palette-explain-drawer"
    >
      {request ? (
        <>
          <Text type="secondary">{request.actionLabel}</Text>
          <ExplanatoryInline
            {...omitUndefined({
              tenantId: request.tenantId,
              actionId: request.actionId,
              actionLabel: request.actionLabel,
              staticReason: request.staticReason,
              focus: request.focus,
              entity: request.entity,
              testId: 'palette-explanatory-inline',
            })}
          />
        </>
      ) : null}
    </Drawer>
  );
}
